
import Vue from "vue";
import Keycloak from "keycloak-js";
import NavBar from "@/components/NavBar.vue";
import AsideMenu from "@/components/AsideMenu.vue";
/*import FooterBar from "@/components/FooterBar.vue";*/
import ExistingUserLogin from "@/components/Customer-Communication/ExistingUserLogin.vue";
import RequestAccess from "@/components/Customer-Communication/RequestAccess.vue";
import CookieConcent from "@/components/CookieConsent.vue";
import {
  AuthService,
  Circul8Account,
  LoginStatusResult
} from "@/services/AuthService";
import { UserAppState } from "@/store";
import { mapGetters } from "vuex";
import { UserGroup } from "@/services/UserGroups";
import { ExternalUserPermissions } from "@/services/PermissionConstant";
import UserPermissionMixin from "@/mixins/UserPermissionMixin";
import UtilityMixin from "@/mixins/UtilityMixin";
import StorageMixin from "@/mixins/StorageMixin";

export default Vue.extend({
  name: "home",
  mixins: [UserPermissionMixin, UtilityMixin, StorageMixin],
  props: {
    keycloak: Keycloak
  },
  components: {
    /*FooterBar,*/
    AsideMenu,
    NavBar,
    ExistingUserLogin,
    RequestAccess,
    CookieConcent
  },
  data() {
    return {
      authService: new AuthService(),
      isPublicRoute: false,
      switchCustomerViewCache: false,
      lastLoadTime: null as number | null
    };
  },
  computed: {
    ...mapGetters([
      "checkingLogin",
      "accessDenied",
      "switchCustomerView",
      "userGroups",
      "mappedCustomer",
      "userTenantExists",
      "isBackendDown",
      "isKeycloakDown",
      "errorMessage"
    ]),
    menu() {
      if (this.checkingLogin || this.accessDenied) {
        return [];
      }
      const switchCustomerData = (this as any).fetchSwitchCustomerCache();
      const mappedCustomer = (this.mappedCustomer || []) as any[];
      let customerInfoMenu = {};
      if ((this as any).userExternalCheck() && mappedCustomer.length > 0) {
        customerInfoMenu = {
          to: "/customers/view/" + mappedCustomer[0],
          href: "/customers/" + mappedCustomer[0],
          label: "Customer Information",
          icon: "account-circle"
        };
      } else if (this.switchCustomerView || this.switchCustomerViewCache) {
        customerInfoMenu = {
          to: "/customers/view/" + switchCustomerData["switchCustomerNumber"],
          href: "/customers/" + switchCustomerData["switchCustomerNumber"],
          label: "Customer Information",
          icon: "account-circle"
        };
      }

      const isExternalOrSwitchUser =
        (this as any).userExternalCheck() ||
        this.switchCustomerView ||
        this.switchCustomerViewCache;
      let showTenantSpecificMenus = true;
      if (isExternalOrSwitchUser && this.userTenantExists === false) {
        showTenantSpecificMenus = false;
      }

      const dataManagementMenu = {
        label: "Data Management",
        subLabel: "Submenus Example",
        icon: "database",
        menu: [
          {
            to: "/datamanagement/products",
            href: "/datamanagement/products",
            icon: "none",
            label: "Products"
          },
          {
            to: "/datamanagement/transactions",
            href: "/datamanagement/transactions",
            icon: "none",
            label: "Transactions"
          }
        ]
      };

      const reportManagerMenu = {
        label: "Report Manager",
        subLabel: "Submenus Report Manager",
        icon: "file-chart-outline",
        menu: [
          {
            to: "/reportManager/reportsList",
            href: "/reportManager/reportsList",
            icon: "none",
            label: "Report List"
          }
        ]
      };

      if (
        (this as any).userExternalCheck() ||
        this.switchCustomerView ||
        this.switchCustomerViewCache
      ) {
        if (switchCustomerData) {
          if (this.userGroups.includes(UserGroup.VIEW_ONLY)) {
            return [
              [
                {
                  to: "/",
                  href: "/",
                  icon: "view-dashboard",
                  label: "Dashboard"
                },
                customerInfoMenu,
                {
                  to: "/reportingtracker",
                  href: "/reportingtracker",
                  label: "Reporting Tracker",
                  icon: "table-search"
                },
                ...(showTenantSpecificMenus
                  ? [dataManagementMenu, reportManagerMenu]
                  : []),
                {
                  to: "/analytics",
                  href: "/analytics",
                  label: "Analytics",
                  icon: "chart-line"
                }
              ]
            ];
          } else {
            return [
              [
                {
                  to: "/",
                  href: "/",
                  icon: "view-dashboard",
                  label: "Dashboard"
                },
                customerInfoMenu,
                {
                  to: "/reportingtracker",
                  href: "/reportingtracker",
                  label: "Reporting Tracker",
                  icon: "table-search"
                },
                ...(showTenantSpecificMenus
                  ? [dataManagementMenu, reportManagerMenu]
                  : []),
                {
                  label: "Compliance Cost",
                  icon: "cash-multiple",
                  menu: [
                    {
                      to: "/compliance",
                      href: "/compliance",
                      icon: "none",
                      label: "Dashboard"
                    },
                    {
                      to: "/playground",
                      href: "/playground",
                      icon: "none",
                      label: "Playground"
                    }
                  ]
                },
                // {
                //   to: "/suppliers",
                //   href: "/suppliers",
                //   label: "Suppliers",
                //   icon: "table-account"
                // },
                {
                  to: "/analytics",
                  href: "/analytics",
                  label: "Analytics",
                  icon: "chart-line"
                },
                {
                  label: "Survey",
                  icon: "poll",
                  menu: [
                    {
                      to: "/survey/overview",
                      href: "/survey/overview",
                      icon: "none",
                      label: "Survey Overview"
                    },
                    {
                      to: "/survey",
                      href: "/survey",
                      icon: "none",
                      label: "Survey"
                    }
                  ]
                }
              ]
            ];
          }
        } else {
          return [
            [
              {
                to: "/",
                href: "/",
                icon: "view-dashboard",
                label: "Dashboard"
              },
              customerInfoMenu,
              {
                to: "/reportingtracker",
                href: "/reportingtracker",
                label: "Reporting Tracker",
                icon: "table-search"
              },
              ...(showTenantSpecificMenus
                ? [dataManagementMenu, reportManagerMenu]
                : []),
              {
                label: "Compliance Cost",
                icon: "cash-multiple",
                menu: [
                  {
                    to: "/compliance",
                    href: "/compliance",
                    icon: "none",
                    label: "Dashboard"
                  },
                  {
                    to: "/playground",
                    href: "/playground",
                    icon: "none",
                    label: "Playground"
                  }
                ]
              },
              // {
              //   to: "/suppliers",
              //   href: "/suppliers",
              //   label: "Suppliers",
              //   icon: "table-account"
              // },
              {
                to: "/analytics",
                href: "/analytics",
                label: "Analytics",
                icon: "chart-line"
              }
            ]
          ];
        }
      } else {
        return [
          [
            {
              to: "/",
              href: "/",
              icon: "view-dashboard",
              label: "Dashboard"
            }
          ],
          [
            {
              to: "/reportingtracker",
              href: "/reportingtracker",
              label: "Reporting Tracker",
              icon: "table-search"
            },

            {
              to: "/customers",
              href: "/customers",
              label: "Customer Profile",
              icon: "account-circle"
            },
            {
              label: "Data Management",
              subLabel: "Submenus Example",
              icon: "database",
              menu: [
                {
                  to: "/datamanagement/products",
                  href: "/datamanagement/products",
                  icon: "none",
                  label: "Products"
                },
                {
                  to: "/datamanagement/transactions",
                  href: "/datamanagement/transactions",
                  icon: "none",
                  label: "Transactions"
                },
                {
                  to: "/datamanagement/import",
                  href: "/datamanagement/import",
                  icon: "none",
                  label: "Import"
                },
                {
                  to: "/datamanagement/importRawData",
                  href: "/datamanagement/importRawData",
                  icon: "none",
                  label: "Data Conversion"
                },
                {
                  to: "/datamanagement/barcodeMatching",
                  href: "/datamanagement/barcodeMatching",
                  icon: "none",
                  label: "Central Matching"
                },
                {
                  to: "/datamanagement/certificates",
                  href: "/datamanagement/certificates",
                  icon: "none",
                  label: "Certificates"
                }
              ]
            },
            {
              label: "Rules Manager",
              subLabel: "Submenus Example",
              icon: "ruler-square-compass",
              menu: [
                {
                  to: "/rulesManager/reportDefinitions",
                  href: "/rulesManager/reportDefinitions",
                  icon: "none",
                  label: "Report Definitions"
                },
                {
                  to: "/rulesManager/scopes",
                  href: "/rulesManager/scopes",
                  icon: "none",
                  label: "Scopes"
                },
                {
                  to: "/rulesManager/rulesList",
                  href: "/rulesManager/rulesList",
                  icon: "none",
                  label: "Rules List"
                }
              ]
            },
            {
              label: "Report Manager",
              subLabel: "Submenus Report Manager",
              icon: "file-chart-outline",
              menu: [
                {
                  to: "/reportManager/reportsList",
                  href: "/reportManager/reportsList",
                  icon: "none",
                  label: "Report List"
                },
                {
                  to: "/reportManager/testingList",
                  href: "/reportManager/testingList",
                  icon: "none",
                  label: "Testing List"
                }
              ]
            },
            {
              to: "/suppliers",
              href: "/suppliers",
              label: "Suppliers",
              icon: "table-account"
            }
          ]
        ];
      }
    }
  },
  created() {
    // Guard against null keycloak (happens when Keycloak initialization fails)
    if (!this.keycloak) {
      console.warn("Keycloak not initialized, skipping created hook");
      return;
    }

    const switchCustomerData = (this as any).fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      (this as any).switchCustomerViewCache =
        switchCustomerData["isSwitchCustomerView"];
    }

    const me = (this as any).prepareAccount();
    (this as any).authService.whoami().subscribe(
      ([permissions]: any) => {
        // Check if response is HTML instead of JSON (server error page)
        if (
          typeof permissions === "string" &&
          permissions.trim().startsWith("<!DOCTYPE")
        ) {
          this.$store.commit("user", {} as UserAppState);
          this.$buefy.dialog.alert({
            title: "Server Error",
            type: "is-danger",
            canCancel: false,
            closeOnConfirm: false,
            message:
              "We're experiencing some technical difficulties at the moment. " +
              "Our team is on it and we'll have the site back up and running shortly. " +
              "<br/><br/>Thank you for your patience."
          });
          return;
        }

        // Check if error object indicates HTML response
        if (permissions?.error?.isHtmlError) {
          this.$store.commit("user", {} as UserAppState);
          this.$buefy.dialog.alert({
            title: "Server Error",
            type: "is-danger",
            canCancel: false,
            closeOnConfirm: false,
            message:
              "We're experiencing some technical difficulties at the moment. " +
              "Our team is on it and we'll have the site back up and running shortly. " +
              "<br/><br/>Thank you for your patience."
          });
          return;
        }

        if (permissions.error && permissions.error["response"]?.status > 400) {
          this.$store.commit("user", {} as UserAppState);
          this.$buefy.dialog.alert({
            title: "Server Error",
            type: "is-danger",
            canCancel: false,
            closeOnConfirm: false,
            message:
              "We're experiencing some technical difficulties at the moment. " +
              "Our team is on it and we'll have the site back up and running shortly. " +
              "<br/><br/>Thank you for your patience."
          });
          return;
        }

        // Check for external user. Force logout if external user is not mapped to any customer
        if (
          permissions?.isExternal == true &&
          permissions?.mappedCustomer?.length == 0
        ) {
          this.$buefy.dialog.alert({
            title: "Login Error",
            type: "is-danger",
            message:
              "It seems your account is not mapped to a customer. Please contact your Customer Account Manager for assistance.",
            onConfirm: () => {
              (this as any).authService.logout(this.keycloak);
            }
          });
        }

        // Logout if no permissions are assigned to the user
        if (permissions?.error == "no-access") {
          this.$buefy.dialog.alert({
            title: "Login Error",
            type: "is-danger",
            message:
              "It seems you don't have access to the application. Please contact System Administrator for assistance.",
            onConfirm: () => {
              (this as any).authService.logout(this.keycloak);
            }
          });
        }

        let switchCustomerPermission = null;
        let switchCustomerGroup = null;
        if (permissions?.groups?.includes(UserGroup.VIEW_ONLY)) {
          switchCustomerPermission = permissions?.permissions;
          switchCustomerGroup = permissions?.groups;
        } else {
          switchCustomerPermission = ExternalUserPermissions;
          switchCustomerGroup = [UserGroup.EXTERNAL_USER];
        }

        this.$store.commit("user", {
          name: me.account?.fullName,
          email: me.account?.email,
          avatar: `https://api.dicebear.com/7.x/initials/svg?seed=${me.account?.fullName}`,
          id: permissions?.id,
          groups:
            switchCustomerData == null
              ? permissions?.groups
              : switchCustomerGroup,
          permissions:
            switchCustomerData == null
              ? permissions?.permissions
              : switchCustomerPermission,
          isExternal:
            switchCustomerData == null ? permissions?.isExternal : true,
          tenantExists: permissions?.tenant_exists,
          mappedCustomer: permissions?.mappedCustomer
        } as UserAppState);
      },
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      (_: any) => {
        if (_.isAxiosError) {
          console.log(
            (_.message || "Unknown Error") + " when trying to identify user"
          );
        } else {
          console.log("Error: user is not logged in", _.message);
          // 2020-12-02 - gf - Redirect to Login page instead of displaying default user John Doe
          // this.authService.login({});
          /*
          this.$buefy.toast.open({
            message: "You are not logged in; please do so",
            type: "is-warning"
          });
          this.$store.commit("user", {
            name: "John Doe",
            email: "john@example.com",
            avatar: "https://avatars.dicebear.com/v2/gridy/John-Doe.svg"
          });
          */
          // Set no user, stop spinner, display login/signup view
          this.$store.commit("user", {} as UserAppState);
        }
      }
    );
  },
  mounted() {
    this.lastLoadTime = Date.now();

    window.addEventListener("storage", event => {
      if (event.key === "switchCustomerView") {
        window.location.reload();
      }
    });

    // Check if we need to refresh due to customer switch in another tab
    const switchCustomerData = this.fetchSwitchCustomerCache();
    const lastSwitchTime = localStorage.getItem("lastSwitchCustomerTime");

    // If we have switch data but haven't reloaded since the last switch
    if (
      switchCustomerData &&
      lastSwitchTime &&
      (!this.lastLoadTime || this.lastLoadTime < parseInt(lastSwitchTime))
    ) {
      // Record that we've loaded
      localStorage.setItem("lastSwitchCustomerTime", Date.now().toString());
      // Reload page to refresh with new customer
      window.location.reload();
    }
    this.$root.$on("storeTokens", () => {
      (this as any).storeAccessTokens(this.keycloak);
    });

    (this as any).isPublicRoute =
      this.$router &&
      this.$router.currentRoute &&
      this.$router.currentRoute.meta &&
      this.$router.currentRoute.meta.isPubliclyAccessible;
  },
  methods: {
    prepareAccount() {
      // Guard against null keycloak
      if (!this.keycloak || !this.keycloak.tokenParsed) {
        console.warn("Keycloak or tokenParsed is null");
        return null;
      }

      // convert keycloak tokenParsed type object to normal javascript object
      const parsedToken = {} as any;
      Object.entries(this.keycloak.tokenParsed).forEach(
        itm => (parsedToken[itm[0]] = itm[1])
      );
      const account: Circul8Account = {
        id: "", // this id field is not used currently within application
        username: parsedToken.preferred_username,
        email: parsedToken.email,
        firstName: parsedToken.given_name,
        lastName: parsedToken.family_name,
        fullName: parsedToken.name
      };

      const loginStatus: LoginStatusResult = {
        loggedIn: this.keycloak.authenticated || false,
        token: this.keycloak.token,
        tokenValidUntil: this.keycloak.tokenParsed?.exp,
        account: account,
        ssoTokenExpired: false
      };
      return loginStatus;
    },
    menuClick(item: any) {
      if (item.action && item.action === "dark-mode-toggle") {
        this.$store.commit("darkModeToggle");
      }
    },
    clearError() {
      this.$store.commit("clearError");
    }
  },
  watch: {
    accessDenied(accessDenied) {
      console.log("ACCESS-DENIED CHANGED TO", accessDenied);
      if (!this.isPublicRoute && accessDenied) {
        /*
        this.$buefy.dialog.alert({
          title: "Access Denied",
          message:
            "It looks like you are not authorized for Circul8 EPR.<br/>Please contact a Circul8 administrator and request access.",
          type: "is-warning",
          hasIcon: true,
          icon: "alert-circle",
          //iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
        */
      }
    },
    checkingLogin() {
      // console.log("CHECKING LOGIN CHANGED TO", checkingLogin);
    },
    "$store.state.customer"(newCustomer) {
      if (newCustomer && newCustomer.isSwitchCustomerView) {
        // Force re-evaluation of computed properties
        this.$forceUpdate();

        // Make sure navbar gets updated too
        this.$nextTick(() => {
          if (this.$refs.navBar) {
            (this.$refs.navBar as Vue).$forceUpdate();
          }
          if (this.$refs.asideMenu) {
            (this.$refs.asideMenu as Vue).$forceUpdate();
          }
        });
      }
    }
  }
});
